import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-d0c922ba"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "statistics-container" }
const _hoisted_2 = { class: "input-seletors-group" }
const _hoisted_3 = { class: "input-seletors" }
const _hoisted_4 = { class: "input-seletors" }
const _hoisted_5 = { class: "seletor-input" }

import { ECharts, EChartsOption, init } from 'echarts';
import { ref, reactive, onMounted, onUnmounted, Ref } from 'vue';
import { formatDate2, queryStatisticsData, TradeOrderAutoAllocConsole } from '../../services';
import { ElInput, ElDatePicker } from 'element-plus';
import 'element-plus/es/components/input/style/css';
import 'element-plus/theme-chalk/el-date-picker.css';
import { debounce, throttle } from 'lodash-es';
import { BigDecimal, RoundingMode } from 'bigdecimal.js';

interface DataItem {
  name: string;
  value: [string, number];
}
interface InputData {
  inputType: string | null;
  dateRange: [Date | null | any, Date | null | any];
  timeUnit?: string | null;
  relationOrderCode?: string | null | any;
  clickDate?: string | null | any;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'AutoAllocStatisticsEcharts',
  props: {
    clickData: null
  },
  setup(__props: any) {

const props = __props as {
  clickData?: (params: InputData | any) => Promise<any>;
}



const echartsRef = ref<HTMLDivElement | null>(null);
let echarts: ECharts | undefined | null = null;

const inputData: InputData = reactive({
  inputType: 'recent-10',
  dateRange: [null, null],
  relationOrderCode: '',
  clickDate: ''
});

let consumeInfo: DataItem[] = [];
let completeInfo: DataItem[] = [];
let resetDataTimerId: undefined | NodeJS.Timeout | number | null;

const addMinutes = (date: Date, minutes: number): Date => {
  const newDate = new Date();
  newDate.setMinutes(date.getMinutes() + minutes);
  return newDate;
};

const changeInputTimeType = throttle((e: string | null) => {
  inputData.inputType = e;
  resetDataTimerId && clearInterval(resetDataTimerId);
  resetDataTimerId = null;
  if (e && e.startsWith('recent-')) {
    inputData.dateRange[0] = new Date();
    inputData.dateRange[1] = addMinutes(inputData.dateRange[0], -Number(e.replace('recent-', '')));
    resetData(true, false);
    resetDataTimerId = setInterval(() => {
      resetData(false, true);
    }, 1000 * 60);
  } else if (e === 'date-range') {
    changeInputDateRange();
  }
});

const changeSearchOrderCode = debounce(async (e?: any) => {
  resetDataTimerId && clearInterval(resetDataTimerId);
  resetDataTimerId = null;
  await resetData(true, false);
  if (inputData.clickDate && inputData.clickDate !== '') {
    props.clickData && props.clickData(inputData);
  }
});
const changeInputDateRange = debounce((e?: any) => {
  resetDataTimerId && clearInterval(resetDataTimerId);
  resetDataTimerId = null;
  inputData.clickDate = '';
  resetData(true, false);
});

// 给图表设置数据
const resetData = async (needClear: boolean, isQueryNext: boolean) => {
  const currentDate = new Date();
  if (echarts) {
    echarts.showLoading();
    const queryInitData = await queryStatisticsData({
      queryStartDate: isQueryNext ? addMinutes(currentDate, -1) : inputData.dateRange[0],
      queryEndDate: isQueryNext ? currentDate : inputData.dateRange[1],
      queryRelationOrderCode: inputData.relationOrderCode
    });
    if (needClear) {
      consumeInfo = [];
      completeInfo = [];
      echarts &&
        echarts.setOption<EChartsOption>({
          series: [
            {
              data: consumeInfo
            },
            {
              data: completeInfo
            }
          ]
        });
    }
    if (queryInitData && !isQueryNext) {
      inputData.timeUnit = queryInitData.queryTimeUnit;
    }
    if (queryInitData && queryInitData.consumeInfo) {
      const resData: DataItem[] = queryInitData.consumeInfo.map((it) => {
        let needAddMinutes = 0;
        switch (inputData.timeUnit) {
          case 'ONE_MINUTE':
            needAddMinutes = 1;
            break;
          case 'TEN_MINUTE':
            needAddMinutes = 10;
            break;
          case 'HALF_HOUR':
            needAddMinutes = 30;
            break;
          case 'ONE_HOUR':
            needAddMinutes = 60;
            break;
          case 'FOUR_HOUR':
            needAddMinutes = 240;
            break;
          case 'HALF_DAY':
            needAddMinutes = 720;
            break;
          case 'ONE_DAY':
            needAddMinutes = 1440;
            break;
          case 'SEVEN_DAY':
            needAddMinutes = 10080;
            break;
          case 'FOURTEEN_DAY':
            needAddMinutes = 20160;
            break;
        }
        return {
          name: it.date + ' - ' + formatDate2(addMinutes(new Date(it.date), needAddMinutes)),
          value: [it.date, it.num ? it.num : 0]
        };
      });
      for (let i = 0; i < resData.length && consumeInfo.length > 0; i++) {
        consumeInfo.unshift();
      }
      consumeInfo.push(...resData);
    }
    if (queryInitData && queryInitData.completeInfo) {
      const resData: DataItem[] = queryInitData.completeInfo.map((it) => {
        return { name: it.date, value: [it.date, it.num ? it.num : 0] };
      });
      for (let i = 0; i < resData.length && completeInfo.length > 0; i++) {
        completeInfo.unshift();
      }
      completeInfo.push(...resData);
    }
    echarts &&
      echarts.setOption<EChartsOption>({
        series: [
          {
            data: consumeInfo
          },
          {
            data: completeInfo
          }
        ]
      });
    echarts && echarts.hideLoading();
  }
};

const resizeChart = (): void => {
  if (echarts) {
    echarts.resize();
  }
};

const initCahart = (): void => {
  let options: EChartsOption = {
    title: {
      text: '寻源任务速率'
    },
    tooltip: {
      trigger: 'axis',
      formatter: function (params: any) {
        params = params ?? [{}, {}];
        return `
          <div>
            <span>时间：${params[0].data.name}</span>
          </div>
          <div>
            <div
              style='display: inline-block;
              width:  10px;
              height: 20px;
              color: ${params[0].color}'
            >●</div>
            <span>寻源总数量：${params[0].data.value[1]}</span>
          </div>
          <div>
            <div
              style='display: inline-block;
              width:  10px;
              height: 20px;
              color: ${params[1].color}'
            >●</div>
            <span>寻源成功数量：${params[1].data.value[1]}</span>
          </div>
          <div>
            <span>成功率：${params[1].data?.value[1] ?? 0 / params[0].data?.value[1] ?? 1}%</span>
          </div>
        `;
      },
      axisPointer: {
        animation: false,
        label: {
          show: true
        }
      }
    },
    xAxis: {
      type: 'time',
      splitLine: {
        show: false
      }
    },
    yAxis: {
      type: 'value',
      boundaryGap: [0, '100%'],
      splitLine: {
        show: false
      }
    },
    series: [
      {
        name: '发起寻源数量',
        type: 'bar',
        data: consumeInfo,
        cursor: 'pointer',
      },
      {
        name: '完成寻源数量',
        type: 'bar',
        data: completeInfo,
        cursor: 'pointer',
      }
    ]
  };

  echarts = init(echartsRef.value);
  echarts.setOption(options);
  changeInputTimeType(inputData.inputType);

  window.addEventListener('resize', resizeChart);

  props.clickData &&
    echarts.on('click', (e) => {
      inputData.clickDate = e.value ? e.value[0] : null;
      props.clickData && props.clickData(inputData);
    });
};

onMounted(() => {
  initCahart();
});

onUnmounted(() => {
  echarts && echarts.dispose();
  resetDataTimerId && clearInterval(resetDataTimerId);
  resetDataTimerId = null;
  window.removeEventListener('resize', resizeChart);
});

return (_ctx: any,_cache: any) => {
  const _component_a_select_option = _resolveComponent("a-select-option")!
  const _component_a_select = _resolveComponent("a-select")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_unref(ElInput), {
          modelValue: inputData.relationOrderCode,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((inputData.relationOrderCode) = $event)),
          class: "seletor-input",
          placeholder: "请输入订单/要货计划编码",
          onChange: _unref(changeSearchOrderCode)
        }, null, 8, ["modelValue", "onChange"])
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_a_select, {
          value: inputData.inputType,
          class: "seletor-input",
          onChange: _unref(changeInputTimeType)
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_select_option, { value: "recent-10" }, {
              default: _withCtx(() => [
                _createTextVNode("最近10分钟")
              ]),
              _: 1
            }),
            _createVNode(_component_a_select_option, { value: "recent-15" }, {
              default: _withCtx(() => [
                _createTextVNode("最近15分钟")
              ]),
              _: 1
            }),
            _createVNode(_component_a_select_option, { value: "recent-30" }, {
              default: _withCtx(() => [
                _createTextVNode("最近30分钟")
              ]),
              _: 1
            }),
            _createVNode(_component_a_select_option, { value: "recent-60" }, {
              default: _withCtx(() => [
                _createTextVNode("最近1小时")
              ]),
              _: 1
            }),
            _createVNode(_component_a_select_option, { value: "recent-180" }, {
              default: _withCtx(() => [
                _createTextVNode("最近3小时")
              ]),
              _: 1
            }),
            _createVNode(_component_a_select_option, { value: "recent-300" }, {
              default: _withCtx(() => [
                _createTextVNode("最近5小时")
              ]),
              _: 1
            }),
            _createVNode(_component_a_select_option, { value: "recent-720" }, {
              default: _withCtx(() => [
                _createTextVNode("最近半天")
              ]),
              _: 1
            }),
            _createVNode(_component_a_select_option, { value: "recent-1440" }, {
              default: _withCtx(() => [
                _createTextVNode("最近1天")
              ]),
              _: 1
            }),
            _createVNode(_component_a_select_option, { value: "recent-4320" }, {
              default: _withCtx(() => [
                _createTextVNode("最近3天")
              ]),
              _: 1
            }),
            _createVNode(_component_a_select_option, { value: "recent-10080" }, {
              default: _withCtx(() => [
                _createTextVNode("最近7天")
              ]),
              _: 1
            }),
            _createVNode(_component_a_select_option, { value: "recent-20150" }, {
              default: _withCtx(() => [
                _createTextVNode("最近14天")
              ]),
              _: 1
            }),
            _createVNode(_component_a_select_option, { value: "date-range" }, {
              default: _withCtx(() => [
                _createTextVNode("选择时间范围")
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["value", "onChange"]),
        _createElementVNode("div", _hoisted_5, [
          (inputData.inputType === 'date-range')
            ? (_openBlock(), _createBlock(_unref(ElDatePicker), {
                key: 0,
                clearable: "",
                modelValue: inputData.dateRange,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((inputData.dateRange) = $event)),
                type: "datetimerange",
                "range-separator": " - ",
                "start-placeholder": "请选择起始时间",
                "end-placeholder": "请选择结束时间",
                format: "YYYY-MM-DD HH:mm:ss",
                "date-format": "MM DD, YYYY",
                "time-format": "HH:mm",
                onChange: _unref(changeInputDateRange)
              }, null, 8, ["modelValue", "onChange"]))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    _createElementVNode("div", {
      class: "echarts-container",
      ref_key: "echartsRef",
      ref: echartsRef
    }, null, 512)
  ]))
}
}

})